import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../ui/utils/Responsive';
import { Fieldset } from '../../../../shared/components/fieldset/Fieldset';

export const StyledDetailsFormSection = styled.div`
	padding-bottom: 32px;

	hr {
		margin-bottom: 32px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-bottom: 16px;

		h3 {
			font-size: 22px;
			margin-bottom: 8px;
		}

		hr {
			margin-bottom: 24px;
		}
	}
`;

interface IDetailsFormSectionProps {
	title?: string;
	children?: ReactNode;
}

export const DetailsFormSection = ({
	title,
	children,
}: IDetailsFormSectionProps) => (
	<StyledDetailsFormSection>
		<Fieldset>
			{title && <StyledLegend>{title}</StyledLegend>}
			<hr />
			{children}
		</Fieldset>
	</StyledDetailsFormSection>
);

const StyledLegend = styled.legend`
	font-size: 32px;
	font-weight: 700;
`;
